import script from "./Billing.vue?vue&type=script&setup=true&lang=js"
export * from "./Billing.vue?vue&type=script&setup=true&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=12efa5e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12efa5e5"]])

export default __exports__